<template lang="html">
  <div class="question box shadow-sm">
    <div class="question-title mb-2">
      <h3 class="pr-2"><em>…{{ question.question }}”</em></h3>
      <div
        v-if="question.questionNumber"
        class="question-number"><h4>Q.{{ question.questionNumber }}</h4>
      </div>
    </div>

    <div
      v-if="form.questions[question.id] !== 120"
      class="form-range-labels my-1">
      <div class="question_label_markings d-flex justify-content-between">
        <p
          v-for="(marking, key) in formattedMarkingTitles"
          :key="key"
          class="question_marking">{{ marking.label }}
        </p>
      </div>
    </div>

    <my360Input
      :form="form"
      :prop="`questions.${question.id}`"
      :input-class="{ 'form-control-range custom-slider': true, 'invalid is-invalid': isInvalid, 'bg-warning': question.ignore }"
      :name="`questions[${question.id}][answer]`"
      :validation-name="__('Question') + question.pivot ? question.pivot.order : '1'"
      :generic-error-msg="__('question_missed')"
      :min="form.questions[question.id] === -1 ? '-1' : '0'"
      :max="form.questions[question.id] === 120 ? '120' : '100'"
      :class="{ 'invisible': form.questions[question.id] === 120 }"
      type="range"
      required />
    <input
      :name="`questions[${question.id}][question]`"
      :value="question.id"
      :generic-error-msg="__('question_missed')"
      type="hidden">
    <input
      :name="`questions[${question.id}][number]`"
      :value="question.questionNumber"
      type="hidden">

    <div
      v-if="showUnableToAnswer"
      class="custom-control custom-checkbox">
      <input
        :id="`unableToAnswerCheck${question.id}`"
        :name="`questions[${question.id}][unable]`"
        v-model="question.ignore"
        type="checkbox"
        class="custom-control-input"
        @change="($event) => onUnableToAnswerChange($event, question)">
      <label
        :for="`unableToAnswerCheck${question.id}`"
        class="custom-control-label">{{ __('label_unable_to_anser') }}</label>
    </div>
  </div>
</template>
<script>
export default {
  name: 'RatingSurveyQuestion',

  props: {
    question: {
      type: [Object],
      required: true
    },

    form: {
      type: [Object],
      required: true
    },

    markingTitles: {
      type: Array,
      required: true
    },

    onUnableToAnswerChange: {
      type: Function,
      required: false,
      default: () => {}
    },

    showUnableToAnswer: {
      type: Boolean,
      required: false,
      default: () => { return false }
    }
  },

  computed: {
    isInvalid () {
      return this.form.questions[this.question.id] === -1
    },

    isReverse () {
      return this.question.reverse
    },

    formattedMarkingTitles () {
      return [...[], ...this.markingTitles]
    }
  }
}
</script>
